import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TableContainer,
  Select,
  Paper,
  TextField,
  IconButton,
  Box,
  Button,
  Autocomplete,
  CircularProgress,
  Checkbox,
  MenuItem, FormControl,
  InputLabel,
  ListItemText,Chip,

} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";


import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

function NonTeachingStaffMeetings() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId, role,pId } = useAuth();
  const [loadingData, setLoadingData] = useState(true); // ✅ Define loading state
  const [teachers, setTeachers] = useState([]);
  const [recipientsRoleUserIds, setRecipients] = useState([]); // Store API data
  const [selectedRoles, setSelectedRoles] = useState([]); // Store selected options
  const [meetings, setMeetings] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

 
   const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;



  const [searchQuery, setSearchQuery] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    recipientsRoleUserIds: [],
    time: "",
    purposeDate: "",
    meetingPurpose: "",
    // time: "",
  });

  const filteredMeetings = meetings.filter((data) => {
    // Convert date to MM/DD/YYYY format
    const formattedDate = new Date(data.purposeDate).toLocaleDateString();

    return (
      data.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      data.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });


            const fetchUsers = async () => {
                try {
                    const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                    if (!response.ok) {
                        throw new Error('Failed to fetch users');
                    }
                    const data = await response.json();
                    setUsers(data);
                    if (data.length > 0) {
                      setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                  }
                } catch (error) {
                    console.error('Error fetching users:', error);
                }
            };
           useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 

  useEffect(() => {
    fetchNonTeachingStaffRoles();
  }, []);

  const fetchNonTeachingStaffRoles = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/employee/getAllEmployeesAndNames/${oId}/${pId}`);
      const data = await response.json();     
  
      if (Array.isArray(data)) {
        // Transform data: Store objects for better selection handling
        setRecipients(data.map((item) => ({
          userId: item.userIds,
          fullName: `${item.firstName} ${item.lastName}`
        }))); 
        // setRecipients(data.map((item) => ({
        //   userId: item.userIds ?? item.emailId,  // <-- fallback to emailId
        //   fullName: `${item.firstName} ${item.lastName}`
        // })));
                    
      } else {
        console.error("API response is not an array:", data);
        setRecipients([]);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setRecipients([]);
    }
  };
  


//  const handleTimeChange = (newValue) => {
//     setFormData({ ...formData, time: dayjs(newValue).format("hh:mm A") }); // Convert to 12-hour format
   
//   };

const handleTimeChange = (newValue) => {
  const formattedTime = newValue ? dayjs(newValue).format("hh:mm A") : "";
  
  setFormData((prev) => ({
    ...prev,
    time: formattedTime,
  }));

  // Real-time validation
  setErrors((prevErrors) => ({
    ...prevErrors,
    time: validateField("time", formattedTime),
  }));
};






  // for getAll api
  const fetchMeetings = async () => {
    setLoadingData(true); // Start loading
    if (!UserId) return;
    try {
      const response = await fetch(`${baseUrl}/api/nonStaffMeeting/nonTeachingGetAllmeetingsById/${UserId}/${oId}`); // Replace with your API URL
      const data = await response.json();
      if (Array.isArray(data)) {
        // ✅ Sort notices by purposeDate (future dates first)
       data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));
        setMeetings(data);
      } else {
        console.error("API response is not an array:", data);
        setMeetings([]); // Set to an empty array if response is invalid
      }
    //   setMeetings(data); // Assuming the response is an array
    } catch (error) {
      console.error("Error fetching notices:", error);
      setMeetings([]);
    }finally {
        setLoadingData(false); // Stop loading
      }
  };
useEffect(() => {
    fetchMeetings();
}, [UserId]);








const validateField = (name, value) => {
  switch (name) {
    case "title":
      // return value.trim() ? "" : "Meeting title is required";
      if (!value.trim()) {
        return "Meeting title is required";
      } else if (!/^[A-Za-z\s]+$/.test(value)) {
        return "Only letters are allowed";
      }

    case "recipientsRoleUserIds":
      return value.length > 0 ? "" : "Select At least one Recipient";

    // case "time":
    //   return value ? "" : "Meeting time is required";

    case "purposeDate":
      if (!value) return "Meeting date is required";
      const today = new Date().toISOString().split("T")[0];
      return value < today ? "Meeting date cannot be in the past" : "";

    case "meetingPurpose":
      if (!value.trim()) return "Meeting purpose is required";
      return value.length < 10 ? "Meeting purpose must be at least 10 characters" : "";

    default:
      return "";
  }
};

const validateForm = () => {
  const newErrors = {};

  // newErrors.title = validateField("title", formData.title);
  if (!formData.title.trim()) {
    newErrors.title = "Meeting title is required";
  } else if (!/^[A-Za-z\s]+$/.test(formData.title)) {
    newErrors.title = "Only letters are allowed";
  }
  newErrors.recipientsRoleUserIds = validateField("recipientsRoleUserIds", formData.recipientsRoleUserIds);
  newErrors.time = validateField("time", formData.time);
  newErrors.purposeDate = validateField("purposeDate", formData.purposeDate);
  newErrors.meetingPurpose = validateField("meetingPurpose", formData.meetingPurpose);

  setErrors(newErrors);
  return Object.values(newErrors).every((error) => !error);
};

const handleChange = (event) => {
  const { name, value } = event.target;
  setFormData((prev) => ({ ...prev, [name]: value }));

  // Real-time validation
  setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: validateField(name, value),
  }));
};



  const handleSubmit = async (e) => {
    e.preventDefault();
   
    setLoading(true);
  
    if (!validateForm()) {
      console.log("Validation failed!");
      setLoading(false);
      return;
    }

    try {
      console.log("🔹 FormData Before Submission:", formData);
  
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      // formDataToSend.append("recipientsRoleUserIds", formData.recipientsRoleUserIds.join(","));  // ✅ Fix here
      // formDataToSend.append("time", formData.time);
      formDataToSend.append("purposeDate", formData.purposeDate);
      formDataToSend.append("meetingPurpose", formData.meetingPurpose);

       // Prepare the recipients list (userIds or emailIds)
    // Build recipients string using userIds or emailId fallback
    const finalRecipients = selectedRoles.map((selectedId) => {
      const user = recipientsRoleUserIds.find(
        (u) => u.userIds === selectedId || u.emailId === selectedId
      );
    
      if (user) {
        // Use userIds if it exists, otherwise use emailId
        return user.userIds ?? user.emailId;
      }
    
      // If not found in recipientsRoleUserIds, just return the selectedId (fallback)
      return selectedId;
    }).filter(Boolean);
    
    
    

    formDataToSend.append("recipientsRoleUserIds", finalRecipients.join(","));



  
     

      const response = await fetch(`${baseUrl}/api/nonStaffMeeting/saveMeetings/${UserId}`, {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();
      

      if (!response.ok) throw new Error(data.message || "Failed to save meeting");

      toast.success("Meeting Scheduled Successfully", { autoClose: 1000 });
      fetchMeetings(); // Refresh meetings list

      setFormData({
        title: "",
        recipientsRoleUserIds: "", 
        time: "",
        purposeDate: "",
        meetingPurpose: "",
      });

    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
};



  
 
  const handleDelete = async (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You Want To Delete Meeting "${data.title}" From The List!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${baseUrl}/api/nonStaffMeeting/delete/${data.id}/${UserId}/${oId}`, {
            method: "DELETE",
          });
  
          if (response.ok) {
           
            toast.success("Meeting Deleted Successfully!");
            fetchMeetings();
            // Optionally refresh notices after deletion
          } else {
           
            toast.error("Failed to delete notice.");
          }
        } catch (error) {
         
          toast.error("An error occurred. Please try again.");
          console.error("Error:", error);
        }
      }
    });
  };

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <CardContent>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", color: "#333", textAlign: "center" }}
        >
          Schedule Non Teaching Staff Notification
        </Typography>

 {/* Two Side-by-Side Grids */}
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "10px", alignItems: "stretch" }}
        >
              {/* GRID-1 */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#ffffff",
                // height: "100%", // Ensure both sections have the same height
                // display: "flex",
                // flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Schedule New Notification
              </Typography>

              <form onSubmit={handleSubmit} style={{ flexGrow: 1 }}>
                <TextField
                  name="title"
                  label="Meeting Title"
                  value={formData.title}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!errors.title}
                  helperText={errors.title}
                />

 {/* Recipients Role Multi-Select */}

<Autocomplete
  multiple
  options={
    recipientsRoleUserIds.length > 0
      ? [{ userId: "ALL", fullName: "Select All" }, ...recipientsRoleUserIds]
      : []
  }
  getOptionLabel={(option) =>
    option.userId === "ALL" ? option.fullName : `${option.fullName} (${option.userId})`
  }
  value={recipientsRoleUserIds.filter((role) => selectedRoles.includes(role.userId))}
  onChange={(event, newValue) => {
    if (newValue.some((val) => val.userId === "ALL")) {
      const allUserIds = recipientsRoleUserIds.map((role) => role.userId);
      setSelectedRoles(allUserIds);
      setFormData((prev) => ({ ...prev, recipientsRoleUserIds: allUserIds }));
    } else {
      const selectedUserIds = newValue.map((role) => role.userId);
      setSelectedRoles(selectedUserIds);
      setFormData((prev) => ({ ...prev, recipientsRoleUserIds: selectedUserIds }));
    }

    // Real-time validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      recipientsRoleUserIds: validateField("recipientsRoleUserIds", newValue.map((role) => role.userId)),
    }));
  }}
  disableCloseOnSelect
  renderTags={(selected, getTagProps) => {
    const visibleItems = selected.slice(0, 3); // Show only first 3 items
    const remainingCount = selected.length - 3; // Count remaining items

    return (
      <>
        {visibleItems.map((option, index) => {
          const user = recipientsRoleUserIds.find((role) => role.userId === option.userId);
          return (
            <Chip
              key={index}
              label={user ? user.fullName : option.userId}
              {...getTagProps({ index })}
              onDelete={() => {
                const updatedRoles = selectedRoles.filter((id) => id !== option.userId);
                setSelectedRoles(updatedRoles);
                setFormData((prev) => ({ ...prev, recipientsRoleUserIds: updatedRoles }));
              }}
              sx={{ margin: "2px" }}
            />
          );
        })}
        {remainingCount > 0 && <span style={{ marginLeft: "8px" }}>+{remainingCount} more</span>}
      </>
    );
  }}
  renderOption={(props, option, { selected }) => (
    <MenuItem {...props}>
      <Checkbox checked={selectedRoles.includes(option.userId)} />
      {option.userId === "ALL" ? option.fullName : `${option.fullName}`}
    </MenuItem>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Select Recipients"
      fullWidth
      sx={{ mb: 2 }}
      placeholder={recipientsRoleUserIds.length === 0 ? "No Recipients To Select" : ""}
      error={!!errors.recipientsRoleUserIds}
      helperText={errors.recipientsRoleUserIds}
    />
  )}
  noOptionsText="No Recipients To Select"
/>









{/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Time"
                    value={
                      formData.time ? dayjs(formData.time, "hh:mm A") : null
                    }
                    onChange={handleTimeChange}
                    sx={{ width: "100%", marginBottom: "10px" }}
                    ampm // Ensures 12-hour format with AM/PM
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: { mb: 1 },
                        error: !!errors.time,
                        helperText: errors.time || " ", // Ensures consistent spacing
                      },
                    }}
                  />
                </LocalizationProvider> */}


              

                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                        label="Time"
                        value={formData.time ? dayjs(formData.time, "hh:mm A") : null}
                        onChange={handleTimeChange}
                        sx={{width:'100%',marginBottom:'10px'}}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            sx={{ mb: 2 }}
                            error={!!errors.time}
                            helperText={errors.time}
                        />
                        )}
                        ampm // Ensures 12-hour format with AM/PM
                    />
                    </LocalizationProvider> */}

                <TextField
                  name="purposeDate"
                  label="Schedule Date"
                  type="date"
                  value={formData.purposeDate}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!errors.purposeDate}
                  helperText={errors.purposeDate}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  name="meetingPurpose"
                  label="Meeting Purpose"
                  multiline
                  rows={3}
                  value={formData.meetingPurpose}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!errors.meetingPurpose}
                  helperText={errors.meetingPurpose}
                />


                  {/* Dropdown for Select User - Right Next to Date Selection */}
                  {/* {isPrincipal && (
                        <Grid item xs={12} sm={14} > 
                          <FormControl fullWidth variant="outlined" size="meddium">
                            <InputLabel>Select Schedule Admin</InputLabel>
                            <Select
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(e.target.value)}
                              label="Select Schedule Admin"
                              // sx={{ height: "44px", display: "flex", alignItems: "center" }} // Matching height
                            >
                              {users.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId} - {user.firstName} {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )} */}




                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      backgroundColor: "#6E69B0",
                      color: "white",
                      minWidth: "130px",
                      "&:hover": {
                        backgroundColor: "#58548E",
                      },
                    }}
                    disabled={loading} // Disable button while loading
                  >
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>


{/* Grid 2 */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Scheduled Notification
              </Typography>

              <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Search by Date or Title"
                    size="small"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="YYYY-MM-DD or Title"
                  />
                </Grid>
              </Grid>

              <Box
                sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }}
              />

               <GlobalStyles
                        styles={{
                          '.custom-sidebar-scrollbar': {
                            scrollbarWidth: 'thin', // For Firefox
                            scrollbarColor: 'grey #e0e0e0',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                            width: '6px', // For WebKit-based browsers
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                            background: '#f1f1f1', // Track color
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                            backgroundColor: 'grey', // Thumb color
                            borderRadius: '10px',
                          },
                          '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: '#555',
                          },
                        }}
                      />

              <Box
                sx={{ maxHeight: "400px", overflowY: "auto" ,padding:'10px'}}
                className="custom-sidebar-scrollbar"
              >
                <Grid container spacing={2}>
                  {loadingData ? ( // Show loader when loading
                        <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Notifications...
                          </Typography>
                        </Box>
                       ) : filteredMeetings.length === 0 ? (
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        color: "#666",
                        width: "100%",
                        padding: "20px",
                        fontStyle: "italic",
                      }}
                    >
                      No Meetings Found, Schedule A New Meeting.
                    </Typography>
                  ) : (
                    filteredMeetings.map((data, index) => (
                      <Grid item xs={12} key={index}>
                        <Box
  sx={{
    padding: "10px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#D1E9F6",
    position: "relative",
    overflow: "hidden",
    marginTop: "10px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#b3d8ec",
    },
    "&:hover .delete-button": { opacity: 1 },
  }}
>
  {/* "New!" Ribbon Badge */}
  {(() => {
    const currentTime = new Date();
    const hasTime = Boolean(data?.time);

let isNew = false;

if (hasTime) {
  const currentTime = new Date();
  const [timeString, period] = data.time.split(" ");
  const [hours, minutes] = timeString.split(":").map(Number);

  let adjustedHours =
    period === "PM" && hours !== 12 ? hours + 12 : hours;
  if (period === "AM" && hours === 12) adjustedHours = 0;

  const noticeDateTime = new Date(data.purposeDate);
  noticeDateTime.setHours(adjustedHours, minutes, 0, 0);

  isNew = currentTime < noticeDateTime;
}


    return isNew ? (
      <Box
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          backgroundColor: "blue",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.75rem",
          padding: "5px 10px",
          textTransform: "uppercase",
          borderTopRightRadius: "8px",
          borderBottomLeftRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        New!
      </Box>
    ) : null;
  })()}

  {/* Delete Icon - Now positioned correctly and shown only on hover */}
  <IconButton
    className="delete-button"
    sx={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: "#ff0000",
      color: "#fff",
      opacity: 0,
      transition: "opacity 0.2s ease-in-out",
      "&:hover": { backgroundColor: "#d32f2f" },
    }}
    onClick={() => handleDelete(data)}
  >
    <DeleteIcon />
  </IconButton>

  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <Box
      sx={{
        backgroundColor: "#4CAF50",
        color: "#fff",
        borderRadius: "8px",
        padding: "10px",
        fontSize: "0.9rem",
        fontWeight: "bold",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          backgroundColor: "#388E3C",
          transform: "scale(1.05)",
        },
      }}
    >
      {data.purposeDate}
    </Box>

    {/* <Box
      sx={{
        backgroundColor: "#4682B4",
        color: "#fff",
        borderRadius: "8px",
        padding: "10px",
        fontSize: "0.9rem",
        fontWeight: "bold",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      }}
    >
      {data.time}
    </Box> */}
  </div>



    {/* Title in single row */}
  <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#444" }}
    >
      Title:
    </Typography>
    <Typography
      variant="h5"
      sx={{ fontWeight: "bold", color: "#333" }}
    >
      {data.title}
    </Typography>
  </Box>
  
  {/* Purpose stacked */}
  <Box sx={{ marginTop: "10px" }}>
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#444" }}
    >
      Purpose:
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: "#666", fontWeight: "bold" }}
    >
      {data.meetingPurpose}
    </Typography>
  </Box>

 
</Box>

                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <ToastContainer position="top-right" autoClose={1000} />
    </Card>
  );
}

export default NonTeachingStaffMeetings;